<template>
    <svg id="Lager_1" data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.6999998 11.6999998">
        <polygon class="cls-1" points="11.5537169 11.553307 11.5537169 4.63244 5.8499999 .1466928 .1462829 4.63244 .1462829 11.553307 11.5537169 11.553307"/>
    </svg>
</template>
<style scoped>
.cls-1 {
    fill: none;
    stroke: #000;
    stroke-linejoin: round;
    stroke-width: .25px;
}
</style>
